import React from 'react';
import Dropdown from "react-bootstrap/Dropdown";
import {CSVLink} from "react-csv";
import {Link} from 'react-router-dom'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';




const BackButton = ({to, text}) =>{
    return (
        <Link to={to}>
            <button className='btn btn-sm sms-btn small-btn mb-2'>
                <ArrowBackIcon/> Back to {text}
            </button>
        </Link>
    )
}


const DataExportButton = ({downLoadPdf, exportCsv, isLoading=false, isExcel=false}) => {
    return (
        <>
            <Dropdown align='start'>
                <Dropdown.Toggle disabled={isLoading} variant="outline-secondary" id="dropdown-basic" style={{paddingBottom:3, paddingTop:3}}>
                    {isLoading ? 'Exporting....':'Export As'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={downLoadPdf} style={{fontSize: '.85em'}}>PDF</Dropdown.Item>
                     {!isExcel ? <Dropdown.Item style={{fontSize: '.85em'}} onClick={exportCsv}>Excel</Dropdown.Item>:null}
                </Dropdown.Menu>
            </Dropdown>
        </>

    )
}
export {BackButton, DataExportButton}
